import React from 'react';
import { Card, CardContent, CardActions, IconButton, Typography, Grid, Menu, MenuItem, Badge, Button } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
// import { getEnvVariable } from '../../../modules/environmentalList';
// import { useHistory, useParams } from "react-router-dom";

const ReusableCard = ({ showActions, item, handleActions }) => {
    // const [anchorEl, setAnchorEl] = React.useState(null);
    // const history = useHistory();

    // const handleMenuOpen = (event) => {
    //     setAnchorEl(event.currentTarget);
    // };

    // const handleMenuClose = () => {
    //     setAnchorEl(null);
    // };

    // const handleGotoUser = () => {
    //     history.push(`/Administration/externalusers/${item.UserId}`);
    // }

    const getPhoneNumber = () => {
        if (item.OfficePhone) return item.OfficePhone;
        if (item.MobilePhone) return item.MobilePhone;
        if (item.HomePhone) return item.HomePhone;
        return ' ';
    };

    return (
        <Card style={{ margin: 2, width: 250, minHeight: 150, maxHeight: 150, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <CardContent>
                <Grid container alignItems="center">
                    <Grid item xs={10}>
                        <Typography variant="body1" style={{ display: 'inline-block', verticalAlign: 'middle', fontWeight: 'bold' }}>{item.CreatedByName}</Typography>
                        <Typography variant="body1" >{item.AccessId ? item.AccessId : " "}</Typography>
                        <Typography variant="body2" >{item.Email ? item.Email : " "}</Typography>
                        <Typography variant="body2" >{getPhoneNumber()}</Typography>
                    </Grid>
                </Grid>
            </CardContent>
            <CardActions sx={{ p: 0, justifyContent: 'flex-start' }}>
                {item.RegistrationStatus === 'P' && showActions ? (
                    <>
                        <Button variant='outlined' size='small' color="primary" onClick={() => { handleActions(item, 'A') }}>
                            <CheckCircleIcon /> Approve
                        </Button>
                        <Button color="secondary" size='small' variant='outlined' onClick={() => { handleActions(item, 'D') }}>
                            <CancelIcon /> Deny
                        </Button>
                    </>
                ) : (
                    <Button
                        variant="contained" disableElevation
                        style={{ pointerEvents: 'none', background: item.RegistrationStatus === 'A' ? '#c8e6c9' : item.RegistrationStatus === 'P' ? 'lightgrey' : '#ffcdd2', }}
                    >
                        {item.RegistrationStatus === 'A' ? 'Approved' : item.RegistrationStatus === 'P' ? 'Pending' : 'Denied'}
                    </Button>
                )}
            </CardActions>
        </Card>
    );
};

export default ReusableCard;